export class DriverAttribute {
    public id: number;
    public customerNumberId: number;
    public driverAttributeTypeId: number;
    public driverCredentialApplicationItemSourceTypeId: number;
    public businessUnitTypeId: number;
    public description: string;
    public updatedBy: string;
    public updatedDate: Date;
}
